import { styled } from "../../config/stiches.config";

export const Container = styled("div", {
  boxSizing: "border-box",
  display: "flex",
});
